import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase.js";

/**
 * Email preferences are stored per account at email_prefs/{uid}.
 * The stats email job (scripts/send-stats.js) skips owners whose
 * statsEmailOptOut is true.
 */

export async function getStatsOptOut(uid) {
  if (!uid) return false;
  const snap = await getDoc(doc(db, "email_prefs", uid));
  return snap.exists() && snap.data().statsEmailOptOut === true;
}

export async function setStatsOptOut(uid, optOut) {
  if (!uid) throw new Error("Missing uid");
  await setDoc(
    doc(db, "email_prefs", uid),
    { statsEmailOptOut: !!optOut, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
